var _rect, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCompany(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#9258E7",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.167 20.5h1.666v1.667h-1.666V20.5zm0-3.333h1.666v1.666h-1.666v-1.666zm0-3.334h1.666V15.5h-1.666v-1.667zm-2.717 0l1.05.7v-.7h-1.05z",
    fill: "#5D43CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.334 10.5v1.258L18 12.867v-.7h7.5v11.666h-3.333V25.5h5v-15H16.333z",
    fill: "#5D43CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.809 12.75l5.691 3.792V25.5H8.834v-8.767l5.975-3.983zm1.525 11.083h2.5V17.3l-4.025-2.558-4.309 2.741v6.35H13v-5h3.334v5z",
    fill: "#5D43CF"
  })));
}

export default __webpack_public_path__ + "230f9183b8d6f0aa53c7ced414fe368e.svg";
export { SvgCompany as ReactComponent };